// components/Hero.jsx
import React from 'react';

const Hero = () => {
  return (
    <div className="bg-cream pt-[70px] min-h-screen">
      <div className="hero grid md:grid-cols-2 items-center gap-16 max-w-[1200px] mx-auto px-8 pb-16">
        <div className="animate-fade-up">
          <div className="inline-flex items-center gap-1.5 bg-teal-light text-teal text-xs font-semibold tracking-[0.8px] uppercase py-1.5 px-3.5 rounded-full mb-6">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
            Trusted Pathology in Dehradun
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl leading-tight text-charcoal mb-5">
            Precise Diagnostics,<br/><span className="text-teal italic">Healthier Lives</span>
          </h1>
          <p className="text-[#4a6662] leading-relaxed mb-8 max-w-md">
            SRM Diagnostic Center offers accurate, affordable, and rapid pathology services — located at Sevla Kala, near Keshav Medical Center, GMS Road, Dehradun.
          </p>
          <div className="flex gap-4 flex-wrap">
            <a href="#contact" className="inline-flex items-center gap-1.5 bg-teal text-white px-8 py-3 rounded-xl font-semibold text-sm hover:bg-teal-dark hover:-translate-y-px transition-all">
              Book Your Test
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </a>
            <a href="#services" className="inline-flex items-center gap-1.5 bg-transparent text-teal px-8 py-3 rounded-xl font-semibold text-sm border-2 border-teal hover:bg-teal-light transition-all">
              Our Services
            </a>
          </div>
          <div className="flex gap-8 mt-8 pt-8 border-t border-[#d5e8e5]">
            <div>
              <h3 className="text-3xl text-teal font-serif">5000+</h3>
              <p className="text-xs text-[#7a9490] font-semibold uppercase tracking-wide">Tests Conducted</p>
            </div>
            <div>
              <h3 className="text-3xl text-teal font-serif">24 hr</h3>
              <p className="text-xs text-[#7a9490] font-semibold uppercase tracking-wide">Report Delivery</p>
            </div>
            <div>
              <h3 className="text-3xl text-teal font-serif">100%</h3>
              <p className="text-xs text-[#7a9490] font-semibold uppercase tracking-wide">Certified Lab</p>
            </div>
          </div>
        </div>

        <div className="hero-visual relative animate-fade-up animation-delay-200">
          <div className="relative p-[30px_30px_40px_10px]">
            <div className="bg-white rounded-2xl p-8 shadow-xl border border-[#e0eeec]">
              <div className="flex items-center justify-between pb-4 border-b border-[#f0f5f4]">
                <div>
                  <p className="text-[0.72rem] text-[#7a9490] font-semibold tracking-wider uppercase">Common Tests</p>
                  <h3 className="text-base text-charcoal mt-0.5">Quick & Reliable</h3>
                </div>
                <div className="bg-teal-light px-3 py-1.5 rounded-lg text-sm text-teal font-semibold">Same Day Reports</div>
              </div>
              <div className="space-y-3 mt-3">
                {['Complete Blood Count (CBC)', 'Blood Glucose (Fasting/PP)', 'Liver Function Test (LFT)', 'Thyroid Profile (T3/T4/TSH)', 'Urine Routine Exam'].map((test, idx) => (
                  <div key={idx} className="flex items-center justify-between py-2 border-b border-[#f0f5f4] last:border-0">
                    <span className="flex items-center gap-2 text-sm font-medium text-charcoal">
                      <span className="w-2 h-2 rounded-full bg-teal"></span>
                      {test}
                    </span>
                    <span className={`text-xs px-2.5 py-0.5 rounded-full font-semibold ${idx === 3 ? 'bg-[#fff7e6] text-[#b07c0f]' : 'bg-teal-light text-teal'}`}>
                      {idx === 3 ? 'Morning Only' : 'Available'}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            <div className="absolute bottom-[-20px] left-[-30px] w-[190px] bg-white rounded-xl p-4 shadow-lg border border-[#e8eeec]">
              <p className="text-[0.7rem] text-[#7a9490] font-semibold uppercase tracking-wide mb-1">Location</p>
              <p className="text-sm text-charcoal font-medium leading-tight">Sevla Kala, GMS Road<br/>Near Keshav Medical</p>
            </div>
            <div className="absolute top-[-25px] right-[-20px] w-[170px] bg-white rounded-xl p-4 shadow-lg border border-[#e8eeec]">
              <p className="text-[0.7rem] text-[#7a9490] font-semibold uppercase tracking-wide mb-1">Timing</p>
              <p className="text-sm text-charcoal font-medium">7:00 AM – 8:00 PM</p>
              <p className="text-xs text-teal mt-0.5">All Days Open</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;